<template>
	<v-row class="pl-0">
		<a-comment-instance
			v-for="(comment, i) in computedComments"
			:key="i"
			:type="type"
			:comment="comment"
		></a-comment-instance>
		<v-col cols="12" class="d-print-none">
			<v-textarea
				filled
				auto-grow
				hide-details
				label="Новый комментарий"
				@keyup.shift.enter="send"
				@keyup.ctrl.enter="send"
				v-model="text"
			>
				<template v-slot:append v-if="allowFiles">
					<v-chip
						v-if="fileNames.length"
						close
						link
						@click="pickFile"
						@click:close="clearFile"
					>
						<div
							class="d-inline-block text-truncate"
							style="max-width: 200px;"
						>
							{{ fileNames }}
						</div>
					</v-chip>
					<v-btn
						icon
						@click="pickFile"
					>
						<v-icon>attach_file</v-icon>
					</v-btn>
				</template>
			</v-textarea>
			<input
				v-if="allowFiles"
				type="file"
				style="display: none"
				ref="files"
				multiple
				@change="onFilePicked"
			>
		</v-col>
		<v-col cols="12" class="d-print-none">
			<v-btn
				class="ml-0"
				color="primary"
				:disabled="!allowSend"
				:loading="loading"
				@click="send"
			>
				Отправить
				<v-icon color="blue" class="ml-2">send</v-icon>
			</v-btn>
		</v-col>
	</v-row>
</template>

<script>
import aCommentInstance from './ACommentInstance.vue'
import {api} from '../../lib/api'

export default {
	components: {
		aCommentInstance
	},
	props: {
		type: String, // pr || po || bud
		id: Number,
		allowFiles: {
			type: Boolean,
			default: true
		},
		changes: {
			type: Boolean,
			default: true
		}
	},
	data: () => ({
		loaded: false,
		loading: false,
		comments: [],
		text: '',
		fileName: [],
		fileExt: [],
		fileUrl: [],
		fileType: [],
		fileSize: [],
		file: [],
		dialog: false,
	}),
	watch: {
		id(val, old) {
			if (val > 0) {
				this.load()
			}
		},
	},
	computed: {
		allowSend() {
			return this.text.trim() || this.fileName.length
		},
		fileNames() {
			let l = this.fileName.length
			if (l > 1) {
				let s = 'ов'
				if (l <= 4) s = 'а'
				return 'Выбрано ' + l + ' файл' + s
			}
			return this.fileName.join(', ')
		},
		computedComments() {
			if (this.changes) return this.comments
			else return this.comments.filter(c =>
				c.systemText !== 'changed'
				&& c.systemText !== 'created'
				&& c.systemText !== 'clone_created'
			)
		},
	},
	methods: {
		clearFile() {
			this.fileName = []
			this.fileExt = []
			this.fileUrl = []
			this.fileType = []
			this.fileSize = []
			this.file = []
		},
		onFilePicked(e) {
			const files = e.target.files
			this.dialog = false
			this.fileName = []
			this.fileExt = []
			this.fileUrl = []
			this.fileType = []
			this.fileSize = []
			this.file = []
			Object.keys(files).forEach(i => {
				const file = files[i]
				if (file !== undefined) {
					if (file.name.lastIndexOf('.') <= 0) {
						return
					}
					this.fileName.push(file.name)
					this.fileExt.push(file.name.split('.').pop())
					this.fileType.push(file.type)
					this.fileSize.push(file.size)
					const fr = new FileReader ()
					fr.readAsDataURL(files[i])
					fr.addEventListener('load', () => {
						this.fileUrl.push(fr.result)
						this.file.push(files[i])
					})
				}
				else {
					this.fileName.push('')
					this.fileExt.push('')
					this.fileUrl.push('')
					this.fileType.push('')
					this.fileSize.push('')
					this.file.push('')
				}
			})
			this.$emit('change', e)
		},
		load() {
			if (!this.id || !this.type) return

			let time = new Date
			// console.log(time.toTimeString().substr(0, 8), 'load comments')

			let d = new Date
			d = d.toISOString()

			api.post('comment/get_comments', {
				type: this.type,
				id: this.id,
				offset: this.comments.length
			})
			.then(response => {
				if (response !== undefined) {
					// почему-то иногда приходил пустой response
					this.comments = this.comments.concat(response.data.comments)

					if (this.$route.params.scroll) {
						this.$vuetify.goTo(99999)
					}
				}
			}, error => {})
		},
		pickFile() {
			this.dialog = true
			this.$refs.files.click()
		},
		send() {
			if (!this.allowSend) return

			this.loading = true

			var formData = new FormData()
			if (this.allowFiles) {
				for (let i = 0; i < this.$refs.files.files.length; i++) {
					formData.append('files[]', this.$refs.files.files[i])
				}
			}
			formData.append('form', JSON.stringify({
				type: this.type,
				id: this.id,
				text: this.text
			}))

			api.post('comment/add_comment', formData)
			.then(response => {
				this.text = ''

				if (this.allowFiles) {
					this.fileName = []
					this.fileExt = []
					this.fileUrl = []
					this.fileType = []
					this.fileSize = []
					this.file = []
				}

				this.loading = false

				this.load()
			}, error => {})
		},
	},
	created() {
		this.load()
	},
}

</script>
